import { useFormContext } from 'react-hook-form';
import {
  IntegrationSettingsEntryRequiredStatus,
  IntegrationSettingsForm,
  IntegrationSettingsTypedInputProps,
} from 'modules/integrationSettings/types';
import { InputField } from 'components/form';

export const StringInput = ({ integrationSettingsEntry, dataKey }: IntegrationSettingsTypedInputProps) => {
  const { control } = useFormContext<IntegrationSettingsForm>();

  const required = integrationSettingsEntry.requiredStatus === IntegrationSettingsEntryRequiredStatus.Required;
  return (
    <InputField
      control={control}
      label={integrationSettingsEntry.displayName}
      rules={{
        required,
      }}
      inputProps={{
        required,
        type: integrationSettingsEntry.name.toLowerCase().includes('password') ? '' : 'text',
      }}
      name={`${integrationSettingsEntry.level}.${dataKey}.integrationSettingsValues.${integrationSettingsEntry.name}`}
    />
  );
};
